import { ActionReducerMapBuilder, Draft } from '@reduxjs/toolkit';

import { createActionTypes, createApiActions } from './rootActions';

const wrapperGetList = () => createApiActions<any, any>(createActionTypes(''));
type List = ReturnType<typeof wrapperGetList>;

export const reducerHelper = <I>(
  builder: ActionReducerMapBuilder<I>,
  action: List,
  key: keyof Draft<I>,
  // @ts-ignore
  initialState?: I[typeof key]['data'],
  notResponse?: boolean,
) => {
  builder.addCase(action.start, (state) => ({
    ...state,
    [key]: {
      ...state[key],
      loading: true,
      data: initialState,
    },
  }));

  builder.addCase(action.stop, (state) => ({
    ...state,
    [key]: {
      ...state[key],
      loading: false,
    },
  }));

  builder.addCase(action.fill, (state, { payload }) => ({
    ...state,
    [key]: {
      ...state[key],
      data: notResponse ? true : payload,
    },
  }));

  builder.addCase(action.error, (state, { payload }) => ({
    ...state,
    [key]: {
      ...state[key],
      error: payload,
    },
  }));
};
